import { TournamentFilter } from '../../../types/TournamentModel';

export const SELECT_TOURNAMENT_DEFAULT_FILTER: TournamentFilter = {
  isDeleted: false,
  isArchived: false,
};
